import React from 'react';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Controller } from 'react-hook-form';

const FormInputMultiCheckbox = ({
  name,
  control,
  label,
  checked,
  register,
  disabled,
}) => {
  return (
    <FormControl size={'small'} variant={'outlined'}>
      <FormControlLabel
        control={
          <Controller
            name={name}
            control={control}
            register={register}
            render={({ field: { onChange, onBlur, value } }) => (
              <Checkbox
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                //checked={checked}
                checked={value}
                disabled={disabled}
              />
            )}
          />
        }
        label={label}
      />
    </FormControl>
  );
};
export default FormInputMultiCheckbox;
